export const OldIdealCustomers1 = [
  "Startups (1 - 10)",
  "Small businesses (10 - 50)",
  "Mid-market (50 - 200)",
  "Business (200+)"
];

export const Under250Business = "Small businesses 1 - 250";

export const IdealCustomers1 = [
  Under250Business,
  "Commercials 251 - 500",
  "Mid-market 501 - 2500",
  "Enterprises 2501 - 10000",
  "Large enterprises 10000+"
];

export const IdealCustomers2 = [
  "Technology/SaaS",
  "E-commerce/Retail",
  "Financial services",
  "Healthcare"
];

export const GeographicFocus = [
  "North America",
  "Europe",
  "Asia Pacific",
  "Global"
];
export const DecisionMakerTitles = [
  "CEO",
  "VP of Sales",
  "VP of Marketing",
  "CTO"
];
